/** Students below this many available points count as "Niedriges Budget". */
export const LOW_BUDGET_THRESHOLD = 20;

export function hasBudget(student) {
  return Boolean(student?.budget && student.budget.total > 0);
}

export function isLowBudget(student) {
  return hasBudget(student) && student.budget.available < LOW_BUDGET_THRESHOLD;
}

/** Most critical first; ties by last name so the order is stable. */
export function compareByAvailable(a, b) {
  return a.budget.available - b.budget.available
    || String(a.lastname).localeCompare(String(b.lastname), 'de');
}
